
const statusIndex = {
    new : "NUEVO",
    inProgress: "EN PROGRESO",
    delivered: "ENVIADO",
    finished: "FINALIZADO",
    canceled:"CANCELADO",
    pending:'PENDIENTE',
    printed:'IMPRESO',
    downloaded:'DESCARGADO',
}

const statusProgress = {
    new : 0,
    inProgress: 60,
    delivered: 30,
    finished: 100,
    canceled:100
}

export const translate = (status) => {
    return statusIndex[status] ? statusIndex[status] : status;
}

export const progress = (status) => {
    return statusProgress[status] ? statusProgress[status] : 0;
}